import { NgOptimizedImage } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CatalogoPublicoService } from '../../services/catalogo-publico.service';
import {
  IMAGEM_PADRAO_MAIS_PROCURADOS,
  ServicoMaisProcurado,
  ServicosMaisProcuradosService,
  montarMaisProcurados,
} from '../../services/servicos-mais-procurados.service';

@Component({
  selector: 'app-servicos-mais-procurados',
  templateUrl: './servicos-mais-procurados.component.html',
  styleUrls: ['./servicos-mais-procurados.component.css'],
  imports: [NgOptimizedImage, RouterLink],
})
export class ServicosMaisProcuradosComponent {
  private readonly maisProcurados = inject(ServicosMaisProcuradosService);
  private readonly catalogo = inject(CatalogoPublicoService);

  /** Os serviços cuja imagem pública não carregou: o card passa para a foto padrão. */
  private readonly imagensComFalha = signal<ReadonlySet<string>>(new Set());

  /**
   * Os mais acessados nos últimos 30 dias, completados pelo catálogo até 4. A falha do ranking
   * vira lista vazia no serviço, e a seção mostra os primeiros do catálogo.
   */
  readonly cards = computed(() =>
    montarMaisProcurados(this.maisProcurados.codigos(), this.catalogo.categorias())
  );

  /**
   * Espera o ranking E o catálogo: com só o catálogo, a seção mostraria os primeiros dele e
   * trocaria os cards logo depois.
   */
  readonly pronto = computed(
    () => !this.maisProcurados.carregando() && !this.catalogo.carregando()
  );

  imagemDe(servico: ServicoMaisProcurado): string {
    return this.imagensComFalha().has(servico.id) ? IMAGEM_PADRAO_MAIS_PROCURADOS : servico.imagem;
  }

  imagemFalhou(id: string): void {
    this.imagensComFalha.update((falhas) => new Set(falhas).add(id));
  }
}
